import { clearAuth, authState } from './auth'

const anonymousKey = 'dingtennis_web_anonymous_id_v1'
const sessionId = `web_${Date.now().toString(36)}_${Math.random().toString(36).slice(2, 10)}`

function anonymousId() {
  const current = localStorage.getItem(anonymousKey)
  if (current) return current
  const created = `anon_${Date.now().toString(36)}_${Math.random().toString(36).slice(2, 10)}`
  localStorage.setItem(anonymousKey, created)
  return created
}

export class ApiError extends Error {
  constructor(public status: number, message: string, public body?: unknown) {
    super(message)
  }
}

export async function api<T>(path: string, init: RequestInit = {}): Promise<T> {
  const headers = new Headers(init.headers)
  headers.set('Accept', 'application/json')
  headers.set('X-Client', 'web')
  headers.set('X-Client-Platform', 'web')
  headers.set('X-App-Version', '0.2.0')
  headers.set('X-Client-Capabilities', 'web-consumer-v1')
  headers.set('X-Client-Device', navigator.userAgent.slice(0, 80))
  headers.set('X-Client-Session-ID', sessionId)
  headers.set('X-Anonymous-ID', anonymousId())
  if (init.body && !(init.body instanceof FormData)) headers.set('Content-Type', 'application/json')
  if (authState.value?.accessToken) headers.set('Authorization', `Bearer ${authState.value.accessToken}`)

  const response = await fetch(path, { ...init, headers })
  let body: any = null
  const contentType = response.headers.get('content-type') || ''
  if (contentType.includes('application/json')) body = await response.json().catch(() => null)
  else body = await response.text().catch(() => '')

  if (!response.ok) {
    if (response.status === 401) clearAuth()
    const message = body?.message || body?.error || (response.status === 401 ? '登录已失效，请重新登录' : '请求失败，请稍后重试')
    throw new ApiError(response.status, Array.isArray(message) ? message[0] : String(message), body)
  }
  return body as T
}

export function queryString(values: Record<string, string | number | boolean | undefined | null>) {
  const params = new URLSearchParams()
  Object.entries(values).forEach(([key, value]) => {
    if (value !== undefined && value !== null && value !== '') params.set(key, String(value))
  })
  const result = params.toString()
  return result ? `?${result}` : ''
}

export function listOf(value: any): any[] {
  if (Array.isArray(value)) return value
  if (Array.isArray(value?.items)) return value.items
  if (Array.isArray(value?.data)) return value.data
  if (Array.isArray(value?.data?.items)) return value.data.items
  return []
}

export function dataOf<T = any>(value: any): T {
  return (value?.data && !Array.isArray(value.data) ? value.data : value) as T
}
